var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 316,
    viewBox: "0 0 388 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1596_20340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.25 194C387.25 300.729 300.729 387.25 194 387.25C87.271 387.25 0.75 300.729 0.75 194C0.75 87.271 87.271 0.75 194 0.75C300.729 0.75 387.25 87.271 387.25 194Z",
    stroke: "url(#paint0_linear_1596_20340)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.951 172.428L178.242 123.414H178.271L178.488 123.039C185.456 110.966 202.89 110.966 209.858 123.039L210.507 122.664L209.858 123.039L238.365 172.428L266.873 221.816C273.841 233.889 265.123 248.992 251.188 248.992H194.158H137.128C123.177 248.992 114.461 233.889 121.443 221.817L121.443 221.816L149.951 172.428Z",
    stroke: "url(#paint1_linear_1596_20340)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.3988,
    cy: 113.399,
    r: 6.3988,
    fill: "#CFC8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1596_20340",
    x1: 194,
    y1: 0,
    x2: 194,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2CA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1596_20340",
    x1: 194.154,
    y1: 113.234,
    x2: 194.154,
    y2: 249.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2CA6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1596_20340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 388,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterLogo);
export default __webpack_public_path__ + "static/media/centerLogo.524d9698654616c1506ac59bd5c01c36.svg";
export { ForwardRef as ReactComponent };